// extracted by mini-css-extract-plugin
export default {"title":"Maintenance_title__gDvN0"};